/**
 * @description: 延时器
 * @param {number} time 时间 ms
 * @returns {}
 */
const delay = (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));

export { delay };
